import api from "../utils/api";
export default {
  namespaced: true,
  state: { templates: [], campaigns: [] },
  mutations: {
    SET_TEMPLATES: (state, payload) => {
      state.templates = payload.templates;
    },
    SET_CAMPAIGNS: (state, payload) => {
      state.campaigns = payload.campaigns;
    }
  },
  actions: {
    getTemplates(context) {
      return api.get(`marketing/template`).then(response => {
        context.commit("SET_TEMPLATES", response);
        return response;
      });
    },
    createTemplate(context, payload) {
      return api.post(`marketing/template`, payload.requestParams);
    },
    resyncStatus() {
      return api.get(`marketing/template/sync`);
    },
    getCampaigns(context) {
      return api.get(`marketing/campaign`).then(response => {
        context.commit("SET_CAMPAIGNS", response);
        return response;
      });
    },
    createCampaign(context, payload) {
      return api.post(`marketing/campaign`, payload.requestParams);
    },
    getMessageLog(context, payload) {
      return api.get(`marketing/messagelog/?page=${payload.page}`);
    },
    getCampaignReport(context, payload) {
      return api.get(`marketing/campaign/report/${payload.campaignId}`);
    }
  },
  getters: {
    getTemplates: state => state.templates,
    getCampaigns: state => state.campaigns
  }
};
